// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11Tz1","badges":"styles_badges__P5d7g"};